export default "__VITE_ASSET__BPzX2U5v__"